import type { Address } from "../../../core/backend/clients/backendClient";

export class ParticipantModel {
  id: number = 0;
  userId: number = 0;
  name: string = "";
  ssn?: string;
  birthDate?: Date;
  address?: Address;
  phone?: string;

  isLoading: boolean = false;

  constructor(init?: Partial<ParticipantModel>) {
    if (init) Object.assign(this, init);
  }
}
